
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6 3C2.429 3 1 6 1 6s1.429 3 5 3c3.571 0 5-3 5-3S9.571 3 6 3z","stroke":"#AAA0D4","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M6 8a2 2 0 100-4 2 2 0 000 4z","stroke":"#AAA0D4","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M1 9l10-6","stroke":"#AAA0D4","stroke-linecap":"round"}})])
          )
        }
      }
    